import { SVGProps } from 'react';

const SvgErrorOutline = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="M8 4.667c.367 0 .667.3.667.666V8c0 .367-.3.667-.667.667A.669.669 0 0 1 7.333 8V5.333c0-.366.3-.666.667-.666Zm-.007-3.334A6.663 6.663 0 0 0 1.333 8c0 3.68 2.98 6.667 6.66 6.667A6.67 6.67 0 0 0 14.667 8a6.67 6.67 0 0 0-6.674-6.667Zm.007 12A5.332 5.332 0 0 1 2.667 8 5.332 5.332 0 0 1 8 2.667 5.332 5.332 0 0 1 13.333 8 5.332 5.332 0 0 1 8 13.333Zm.667-2H7.333V10h1.334v1.333Z" />
    </svg>
);
export default SvgErrorOutline;
